import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
	name: 'designation'
})
export class DesignationPipeMock implements PipeTransform {

	transform(value: any, args?: any): any {
		return value;
	}

}
